(function() {
	'use strict';

	var cartLink = document.querySelectorAll('[data-role="cart-link"]');

	// update URL so it contains campaign tracking
	for(var i = 0; i < cartLink.length; i++){
		cartLink[i].href = 'https://checkout.avast.com/en-gb/web?product=sbd.5.12m.sb&quantity=1&campaign=WA-UKSTUDENT&currency=GBP&clearCart=1&utm_medium=affiliate&utm_source=commissionjunction&utm_campaign=4033223&utm_content=15357298&couponfield=yes&cjevent=c057b620be6bec3dc246b4f4f903c326370405a12e9515ae9';
	}
})();


/*

	DEV note: to enable the Unidays iFrame
	- uncomment following code and remove the code above
	- uncomment the Unidays iFrame in TEXT: https://web-cms.ff.int.avast.com/all/text/edit/23f5d40db847e64be53c07be14aa0e15

(function() {
	'use strict';

	var $ = avm.require('cash'),
		ctaButtons = document.querySelectorAll('.btn-primary'),
		cartLink = document.querySelectorAll('[data-role="cart-link"]'),
		modalButton = document.querySelector('[data-target="#modalUnidays"]');

	// click on "BUY NOW" button will open modal with UniDays <iframe>
	for(var i = 0; i < ctaButtons.length; i++){
		ctaButtons[i].addEventListener('click', function(e){
			e.preventDefault();	// disable redirect to Cart
			modalButton.click();	// display Unidays modal (simulate click on hidden button)
		});
	}

	// remove link from "BUY NOW" link so visitor can't access the Cart by copying the URL
	for(var i = 0; i < cartLink.length; i++){
		cartLink[i].href = "#";
	}

})();
*/
